import ajax from '@/utils/ajax';

export const head = '/web';

// 天猫订单激活
export const resCourseTmall = (data) => ajax(`${head}/v1/order/open`, data, 'POST');

// 天猫订单激活
export const resCourseTmallSku = (tid, channelType) => ajax(`${head}/v1/order/product-sku-options?tid=${tid}&channelType=${channelType}`);
// 校验防伪码
export const reqcheckCode = (data) => (ajax(`${head}/v1/tool/security-code/v2/open`,data, 'PUT'));
